export const wordSlider = ()=> {
    const typedTextSpan = document.querySelector(".hero__title-slider");
    const cursorSpan = document.querySelector(".hero__title-cursor");

    const words = document.querySelectorAll('.hero__title-word');
    const textArray = Array.from(words).map((item)=> {
        return item.innerHTML
    })

    // const textArray = [ "Cloud", "Applications", "Network"];
    const typingDelay = 100;
    const erasingDelay = 80;
    const newTextDelay = 1500; // Delay between current and next text
    let textArrayIndex = 0;
    let charIndex = 0;

    function type() {
        if (charIndex < textArray[textArrayIndex].length) {
            if(!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            typedTextSpan.textContent += textArray[textArrayIndex].charAt(charIndex);
            charIndex++;
            setTimeout(type, typingDelay);
        }
        else {
            cursorSpan.classList.remove("typing");
            setTimeout(erase, newTextDelay);
        }
    }

    function erase() {
        if (charIndex > 0) {
            if(!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            typedTextSpan.textContent = textArray[textArrayIndex].substring(0, charIndex-1);
            charIndex--;
            setTimeout(erase, erasingDelay);
        }
        else {
            cursorSpan.classList.remove("typing");
            textArrayIndex++;
            if(textArrayIndex>=textArray.length) textArrayIndex=0;
            setTimeout(type, typingDelay + 500);
        }
    }

    if(textArray.length) setTimeout(type, newTextDelay + 20);
}